<template>
    <GekkoButton 
        @click="undoDowngrade()" 
        :text="$gettext('Undo downgrade')" 
        icon="fa-solid fa-rotate-left"
        class="mt-2"
    />
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import SubscriptionService from "@/store/services/subscriptions.service";

export default {
    name: "ActionButtonUndo",
    components: {GekkoButton},
    methods: {
        undoDowngrade() {
            let vm = this;
            SubscriptionService.undoCancelSubscription(this.$store.getters['subscriptionStore/getSubscription'].id).then(function() {
                vm.$router.go();
                vm.$store.commit('setAlert', {
                    vm: vm,
                    title: vm.$gettext("Info"),
                    text: vm.$gettext("Your subscription has been re-activated."),
                    duration: 4
                });
            });
        }
    }
}
</script>
